 import { NgModule } from '@angular/core';
 import { CommonModule } from '@angular/common';
 import { DateNlDirective } from './date-nl.directive';
 import { NumberNlDirective } from './number-nl.directive';
 import { PostcodeNlDirective } from './postcode-nl.directive';
 import { ValidationMessageDirective } from './validation-message.directive';
 import { ApplyErrorClassDirective } from './apply-error-class.directive';
 import { WorkingHoursValidatorDirective } from './workinghours.directive';

 @NgModule({
     imports: [CommonModule],
     exports: [DateNlDirective, NumberNlDirective, PostcodeNlDirective, ValidationMessageDirective, ApplyErrorClassDirective, WorkingHoursValidatorDirective],
     declarations: [DateNlDirective, NumberNlDirective, PostcodeNlDirective, ValidationMessageDirective, ApplyErrorClassDirective, WorkingHoursValidatorDirective],
 })
 export class ValidationModule { }
